// The Android app (a Trusted Web Activity built in ~/projects/angel-isp-customer-twa, signed APK in
// public/downloads/). crm-isp has its own copy of this file pointing at the Orvyn APK.
export const APK_URL = '/downloads/lcv-crm.apk';
export const APK_NAME = 'LCV CRM';
